import Image from './image'
import Video from './image'
import Logo from './logo'
import Gallery from './gallery'

const TYPES_MAP = {
  'media/image': Image,
  'media/video': Video,
  'media/logo': Logo,
  'media/gallery': Gallery
}

export { TYPES_MAP, Image, Video, Logo, Gallery }


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/media/index.js